// B4: a colleague's case lives under its owner's Firestore path. The case
// list links to /case/<id>?owner=<uid>; EditCase and CaseSubBar resolve the
// owner from that query parameter. An absent or malformed value means "my
// own case", so every pre-B4 link still resolves.

// Same shape as BillingPage's FACILITY_ID_RE: Firebase uids and our seeded
// test ids are short, URL-safe tokens. A slash would escape the path.
export const OWNER_UID_RE = /^[A-Za-z0-9_-]{1,128}$/;

/**
 * Return the uid whose path holds the case being viewed.
 *
 * @param {URLSearchParams} searchParams from useSearchParams()
 * @param {string|undefined} uid the signed-in user's uid
 * @returns {string|undefined} the validated ?owner= value, else uid
 */
export function resolveCaseOwner(searchParams, uid) {
    const requested = searchParams?.get('owner');
    return requested && OWNER_UID_RE.test(requested) ? requested : uid;
}
